import React, { useState } from "react";
import { Tab, Nav, Button } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Conversations from "./Conversations";
import Contacts from "./Contacts";
import NewContactModal from "./NewContactModal";
import NewConversationModal from "./NewConversationModal";

const CONVERSATIONS_KEY = "conversations";
const CONTACTS_KEY = "contacts";

export default function Sidebar({ id }) {
  const [activeKey, setActiveKey] = useState(CONVERSATIONS_KEY);
  const [modalOpen, setModalOpen] = useState(false);
  const conversationsOpen = activeKey === CONVERSATIONS_KEY;

  function closeModal() {
    setModalOpen(false);
  }

  const activeTabStyle = {
    backgroundColor: "#667eea",
    color: "white",
    fontWeight: 600,
    borderBottom: "2px solid #667eea",
  };

  const inactiveTabStyle = {
    color: "#6c757d",
    backgroundColor: "#f8f9fa",
  };

  return (
    <div
      style={{
        width: "320px",
        backgroundColor: "#ffffff",
        boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
        borderRight: "1px solid #e9ecef",
      }}
      className="d-flex flex-column"
    >
      <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
        <Nav
          variant="tabs"
          className="justify-content-center"
          style={{
            borderBottom: "1px solid #e9ecef",
            backgroundColor: "#f8f9fa",
            flexShrink: 0,
          }}
        >
          <Nav.Item style={{ flex: 1 }}>
            <Nav.Link
              eventKey={CONVERSATIONS_KEY}
              style={
                activeKey === CONVERSATIONS_KEY
                  ? activeTabStyle
                  : inactiveTabStyle
              }
              className="text-center"
            >
              💬 Percakapan
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flex: 1 }}>
            <Nav.Link
              eventKey={CONTACTS_KEY}
              style={
                activeKey === CONTACTS_KEY ? activeTabStyle : inactiveTabStyle
              }
              className="text-center"
            >
              👥 Kontak
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content
          className="flex-grow-1"
          style={{
            backgroundColor: "#ffffff",
            overflowY: "auto",
            overflowX: "hidden",
            minHeight: 0,
          }}
        >
          <Tab.Pane eventKey={CONVERSATIONS_KEY}>
            <Conversations id={id} />
          </Tab.Pane>
          <Tab.Pane eventKey={CONTACTS_KEY}>
            <Contacts />
          </Tab.Pane>
        </Tab.Content>
        {conversationsOpen && (
          <Button
            onClick={() => setModalOpen(true)}
            style={{
              margin: "15px",
              borderRadius: "25px",
              backgroundColor: "#667eea",
              border: "none",
              padding: "12px 20px",
              fontWeight: 600,
              boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
              transition: "all 0.3s ease",
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#5568d3";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#667eea";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
            }}
          >
            ➕ Percakapan Baru
          </Button>
        )}
      </Tab.Container>

      <Modal
        size="md"
        isOpen={modalOpen}
        toggle={() => closeModal()}
        contentClassName="p-0"
        modalClassName="modal-slide-in event-sidebar"
      >
        <ModalHeader toggle={() => closeModal()}>
          <div>
            <div className="headline-2">{"Percakapan Baru"}</div>
          </div>
        </ModalHeader>
        <ModalBody>
          <NewConversationModal closeModal={closeModal} id={id} />
        </ModalBody>
      </Modal>
    </div>
  );
}
